import type { Invoice } from "$global-providers/rxdb-provider/collections/invoice";
import {
  type FinaliseInvoiceInput,
  Invoice as InvoiceModel,
} from "$routes/_lib/billing-v2/invoice";
import type { CalculatedInvoice } from "$routes/_lib/billing-v2/invoice-source";

export const buildFinalisedInvoice = (
  invoice: Invoice,
  args: {
    actionedByUserId: string;
    timestamp: string;
    insurerCharges: FinaliseInvoiceInput["insurerCharges"];
  },
): CalculatedInvoice => {
  const model = InvoiceModel.fromRecord(invoice);
  return model
    .finalise({
      actionedByUserId: args.actionedByUserId,
      timestamp: args.timestamp,
      priceListLastSyncedAt: invoice.priceListLastSyncedAt,
      insurerCharges: args.insurerCharges,
    })
    .toRecord();
};
